import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/generic_user.svg'


const _withScopeId = n => (_pushScopeId("data-v-517c1d83"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "authContainer" }
const _hoisted_2 = { class: "createAcountContainer" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "error"
}
const _hoisted_5 = { class: "buttons" }

import HeyButton from "@/components/HeyButton.vue";
import NextIcon from "@/components/Icons/NextIcon.vue";
import BackIcon from "@/components/Icons/BackIcon.vue";
import ErrorIcon from "@/components/Icons/ErrorIcon.vue";
import LogoIcon from "@/components/Icons/LogoIcon.vue";
import router from "@/router";
import axios, { AxiosError } from "axios";
import { useStore } from "vuex";
import { ref, onMounted, computed } from "vue";
import sleep from "@/sleep";

// Vuex Store

export default /*#__PURE__*/_defineComponent({
  __name: 'AuthView',
  setup(__props) {

// Imports
const store = useStore();
computed(() => store.state.authStatus);

// Variables - UI
const heading = ref("");
const subheading = ref("");
const showCreateAccount = ref(false);
const error = ref("");
const loading = ref(false);

// Variables - HTML Inputs
const email = ref<HTMLInputElement | null>(null);
const name = ref<HTMLInputElement | null>(null);

// Switch to Log In View
function showLogInScreen() {
  showCreateAccount.value = false;

  heading.value = "Enter your email";
  subheading.value = "First time using Hey? An account will be created for you";
  error.value = "";
}

// Switch to Create Account View
function showCreateAccountScreen() {
  showCreateAccount.value = true;

  heading.value = "Customize profile";
  subheading.value = "";
  error.value = "";
}

function isEmailValid(email: string | undefined) {
  // Valid Email Regular Expression
  const emailRegex = /^[^\s@]+@[^\s@.]+\.[^\s@.][^\s@]*$/;

  // Do validations on email
  if (!email) {
    error.value = "Email is required";
  } else if (!emailRegex.test(email)) {
    error.value = "Invalid email";
  }

  return error.value === "";
}

// Create unverified session
async function createSession() {
  // Don't allow duplicate requests if one's already processing/there's an error that hasn't been addressed
  if (loading.value || error.value) return;

  loading.value = true;
  await sleep(500); // Pause script so user can see loading spinner on button in case request is really short

  // Email Validation
  if (!isEmailValid(email.value?.value)) {
    return (loading.value = false);
  }

  try {
    // Send HTTP reuqest to create session
    await axios.post("/sessions/create", { email: email.value?.value });

    // Update Vuex Store To Set Auth Status To 1
    store.dispatch("createSession");

    loading.value = false;

    router.push("/verify");
  } catch (error) {
    loading.value = false;

    if (error instanceof AxiosError && error.response?.status == 404) {
      return showCreateAccountScreen();
    }

    throw error;
  }
}

// Create user account
async function createAccount() {
  // Don't allow duplicate requests if one's already processing/there's an error that hasn't been addressed
  if (loading.value || error.value) return;

  loading.value = true;
  await sleep(500); // Pause script so user can see loading spinner on button in case request is really short

  // Email Validation
  if (!name.value?.value) {
    error.value = "Name is required";
    return (loading.value = false);
  }

  try {
    const data = { email: email.value?.value, name: name.value?.value };

    // Send HTTP reuqest to create account
    await axios.post("/users/create", data);
  } catch (error) {
    loading.value = false;

    if (error instanceof AxiosError && error.response?.status == 404) {
      return showCreateAccountScreen();
    }

    throw error;
  }

  try {
    // Send HTTP reuqest to create session
    await axios.post("/sessions/create", { email: email.value?.value });

    // Update Vuex Store To Set Auth Status To 1
    store.dispatch("createSession");

    router.push("/verify");
  } catch {
    showLogInScreen();
    error.value = "Account created successfully, failed to create session";
  }

  loading.value = false;
}

onMounted(showLogInScreen);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LogoIcon, { style: {"height":"1.5em"} }),
    _createElementVNode("h1", null, _toDisplayString(heading.value), 1),
    _createElementVNode("p", null, _toDisplayString(subheading.value), 1),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("input", {
        type: "email",
        ref_key: "email",
        ref: email,
        placeholder: "Your email…",
        maxlength: "255",
        class: _normalizeClass(error.value ? 'error' : ''),
        onKeydown: [
          _cache[0] || (_cache[0] = ($event: any) => (error.value = '')),
          _cache[1] || (_cache[1] = _withKeys(($event: any) => (createSession()), ["enter"]))
        ]
      }, null, 34)
    ], 512), [
      [_vShow, !showCreateAccount.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createElementVNode("input", {
          type: "text",
          ref_key: "name",
          ref: name,
          maxlength: "255",
          placeholder: "Your name…",
          class: _normalizeClass(error.value ? 'error' : ''),
          onKeydown: [
            _cache[2] || (_cache[2] = ($event: any) => (error.value = '')),
            _withKeys(createAccount, ["enter"])
          ]
        }, null, 34)
      ])
    ], 512), [
      [_vShow, showCreateAccount.value]
    ]),
    (error.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
          _createElementVNode("span", null, [
            _createVNode(ErrorIcon)
          ]),
          _createTextVNode(" " + _toDisplayString(error.value), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(HeyButton, {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (showCreateAccount.value ? showLogInScreen() : _unref(router).push('/'))),
        type: "secondary"
      }, {
        default: _withCtx(() => [
          _createVNode(BackIcon),
          _createTextVNode(" Go Back ")
        ]),
        _: 1
      }),
      _createVNode(HeyButton, {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (showCreateAccount.value ? createAccount() : createSession())),
        loading: loading.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Continue "),
          _createVNode(NextIcon)
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ]))
}
}

})